import { render } from "./SmallQuestionIcon.vue?vue&type=template&id=2640801d&scoped=true"
import script from "./SmallQuestionIcon.vue?vue&type=script&lang=js"
export * from "./SmallQuestionIcon.vue?vue&type=script&lang=js"

import "./SmallQuestionIcon.vue?vue&type=style&index=0&id=2640801d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2640801d"

export default script